export enum RECOMMEND_TAB_IDS {
    BASE = 'base',
    COVER = 'cover',
    CONTENTS = 'contents',
    CHAPTER = 'chapter',
    TEXT = 'text',
    END = 'end',
    TEMPLATE = 'TEMPLATE',
}
